export default "__VITE_ASSET__edMHasgZ__"